export default __webpack_public_path__ + "static/media/step2.a018e3b9.svg";